import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getGroupList } from '../services/manage/groupmanagement';
import { saveGroupList } from '../store/manage/group';

interface Group {
  id: string;
  name: string;
  [key: string]: any;
}

interface UseGroupListReturn {
  groupList: Group[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useGroupList = (
  authContext: any, 
  t: (key: string) => string,
  showToast?: (type: string, message: string) => void
): UseGroupListReturn => {
  const [groupList, setGroupList] = useState<Group[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();

  const fetchGroupList = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = { token: authContext.token };
      const response = await getGroupList(params);
      
      if (response?.result?.code === '0000' && Array.isArray(response?.data.groups)) {
        setGroupList(response.data.groups);
        dispatch(saveGroupList(response.data.groups));
      } else {
        throw new Error('Invalid response format or no groups found');
      }
    } catch (error) {
      console.error('Error fetching group list:', error);
      const errorMessage = t('error_fetching_data');
      setError(errorMessage);
      
      if (showToast) {
        showToast('error', errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authContext.token) {
      fetchGroupList();
    }
  }, [authContext.token]);

  return {
    groupList,
    loading,
    error,
    refetch: fetchGroupList,
  };
};